import { render } from "./AlignLeft.vue?vue&type=template&id=6076d3b2&scoped=true"
const script = {}

import "./AlignLeft.vue?vue&type=style&index=0&id=6076d3b2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6076d3b2"]])

export default __exports__